(function () {
    'use strict';
    $(document).ready(function () {
        const $postsWrapper = $('.posts-wrapper');
        const $errorsWrapper = $('.errors-wrapper');
        const $loader = $('.loader');
        const postsPerPage = 6;
        let paged = parseQueryParams(location.search)['strona'] || 1;
        let currentTerm = parseQueryParams(location.search)['term'] || 'all';
        let isFetching = false;

        getNews();
        $('.news-list .term-tab').on('click', handleSelectNewsTerm);
        $(document).on('click', '.posts-wrapper .pagination .page-numbers:not(.dots, .current)', handlePaginationChange)


        /**
         * @function Load news from server
         */
        function getNews() {
            if (!isFetching) {
                $.ajax({
                    url: "/wp-admin/admin-ajax.php",
                    method: "post",
                    data: {
                        action: 'get_news',
                        page: paged,
                        ppp: postsPerPage,
                        term: currentTerm
                    },
                    // cache: false,
                    success: function (data) {
                        $loader.fadeOut();
                        setTimeout(function () {
                            $('section.content').addClass('has-data');
                            $postsWrapper.html(data).fadeIn();
                        }, 300);
                        // scrollToFirstPost();
                    },
                    error: function (error) {
                        $loader.fadeOut();
                        console.error('⚠', error);
                        setTimeout(function () {
                            $errorsWrapper.fadeIn();
                        }, 300);
                        // scrollToFirstPost();
                    },
                    beforeSend: function () {
                        isFetching = true;
                        $errorsWrapper.fadeOut();
                        $postsWrapper.fadeOut();
                        $('section.content').removeClass('has-data');
                        setTimeout(function () {
                            $loader.fadeIn();
                        }, 300);
                    },
                    complete: function () {
                        isFetching = false;
                    },
                });
            }
        }


        /**
         * @function Click handler for news tabs
         */
        function handleSelectNewsTerm() {
            if (!isFetching) {
                const prevTerm = currentTerm;
                currentTerm = $(this).data('term');
                if (prevTerm !== currentTerm)
                    paged = 1;
                $('ul.nav .term-tab.active').removeClass('active');
                $(this).addClass('active');
                getNews();
                updateQueryParams({ term: currentTerm === 'all' ? null : currentTerm, strona: paged });
            }
        }

        /**
         * @function Click handler for pagination
         */
        function handlePaginationChange(e) {
            e.preventDefault();
            const $this = $(this);
            if ($this.hasClass('prev')) {
                paged -= 1;
            } else if ($this.hasClass('next')) {
                paged += 1;
            } else {
                paged = parseInt($this.text())
            }

            updateQueryParams({ strona: paged });
            getNews();
        }


        /**
         * @function Scrolls to first post
         */
        function scrollToFirstPost() {
            $('html, body').animate({ scrollTop: $postsWrapper.offset().top + 200 }, 600);
        }


        /**
         * @function Updates query params in url
         * @param {object|null} newParamsString
         */
        function updateQueryParams(newParamsString) {
            let finalParams = '?';
            if (newParamsString !== null) {
                let queryParams = {};
                if (location.search.length !== 0)
                    queryParams = parseQueryParams(location.search);

                finalParams = stringifyQueryParams({ ...queryParams, ...newParamsString });
            }
            window.history.pushState(
                null,
                '',
                location.hash.replace(location.search, '') + finalParams
            );
        }


        /**
         * @function Updates query params in url
         * @param {object} params
         */
        function stringifyQueryParams(params) {
            return `?` + Object
                .keys(params)
                .reduce((accumulator, currentValue) => {
                    if (params[currentValue])
                        return [...accumulator, [currentValue, params[currentValue]].join('=')]
                    else
                        return [...accumulator];
                }, [])
                .join('&');
        }


        /**
         * @function Updates query params in url
         * @param {string} params
         */
        function parseQueryParams(params) {
            if (params.length === 0) return false;

            return params
                .substring(1)
                .split('&')
                .map(
                    (p) => {
                        const splittedParam = p.split('=');
                        return { [splittedParam[0]]: splittedParam[1] }
                    }
                )
                .reduce((accumulator, currentValue) => ({ ...accumulator, ...currentValue }), {});
        }

    });
}(jQuery));